import Stickyfill from "stickyfilljs";

Stickyfill.forceSticky();

let pageMenuElems;
let sidebarElems;

function handleMediaChange(e) {
    if (e.matches) {
        Stickyfill.add(pageMenuElems);
        Stickyfill.remove(sidebarElems);
    } else {
        Stickyfill.remove(pageMenuElems);
        Stickyfill.add(sidebarElems);
    }
}

function el(selector) {
    return document.querySelectorAll(selector);
}

$(function () {
    pageMenuElems = el(".js-stickyfill-page-menu");
    sidebarElems = el(".js-stickyfill-sidebar");

    const mobileMediaQuery = window.matchMedia("(max-width: 991.98px)");

    mobileMediaQuery.addEventListener("change", handleMediaChange);

    handleMediaChange(mobileMediaQuery);
});
